import { PlaybackType } from '../core/player/playout-data';
import { OvpJourneyContext } from '@sky-uk-ott/core-video-sdk-js-ovp-service';
export function checkIsManifestVodType(playbackType) {
    return [
        PlaybackType.FER,
        PlaybackType.VOD,
        PlaybackType.Clip,
        PlaybackType.Preview,
        PlaybackType.Advert
    ].includes(playbackType);
}
export function checkIsManifestLinearType(playbackType) {
    return [
        PlaybackType.Live,
        PlaybackType.SingleLiveEvent
    ].includes(playbackType);
}
export function checkIsManifestFerType(playbackType) {
    return playbackType === PlaybackType.FER;
}
export function checkIsManifestSingleLiveEventType(playbackType) {
    return playbackType === PlaybackType.SingleLiveEvent;
}
export function checkIsSessionItemSleAutoplayType(sessionItem) {
    return sessionItem.type === PlaybackType.SingleLiveEvent && 'journeyContext' in sessionItem && sessionItem.journeyContext === OvpJourneyContext.SleAutoplay;
}

//# sourceMappingURL=playback-type.js.map